<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
@import '~@/assets/style/public-class.scss';
.d2-layout-header-aside-group .d2-layout-header-aside-content .d2-theme-container .d2-theme-container-main .d2-theme-container-main-body .container-component .d2-container-full .d2-container-full__body {
    margin-bottom:50px; 
}

//-- 公共样式--//

// 弹出框
.el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #E9E9E9;
}
.el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
    border-left:4px solid #02B90D;
    padding-left: 10px; 
}
// 状态-点
.danger,.success,.warning {
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background: #ff3723;
  display: inline-block;
  vertical-align: middle;
}
.success{
  background:#42CD00;
}
.warning{
  background:#FFA101;
}

//-- 公共样式--//
.cropper-view-box {
  outline: 5px solid #39f !important;
}
</style>
